import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  // If still loading auth state, show a loading indicator
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }
  
  // If not authenticated, redirect to login page
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  // If authenticated, render the protected content
  return children;
} 